import { render } from "./TplFooter.vue?vue&type=template&id=bfee199e"
import script from "./TplFooter.vue?vue&type=script&lang=js"
export * from "./TplFooter.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Contex\\Projekte\\dev\\web\\Jacobi Walter\\Schneelastrechner\\02_web\\jacobiwalther_schneelastre_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__